<sk-job-history
  titleText="Resource Job History"
  [jobs]="subscriptionJobs"
  [days]="[7,14,30]"
  [extendedDays]="[45,60]"
  [isRefreshing]="isRefreshing$ | async"
  (refreshEvent)="loadSubscriptionJobs($event)">
</sk-job-history>

